const BACKEND_URL = 'http://localhost:3000';
function formatDuration(iso8601) {
    const match = iso8601.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!match) {
        return '0:00';
    }
    const hours = parseInt(match[1] || '0');
    const minutes = parseInt(match[2] || '0');
    const seconds = parseInt(match[3] || '0');
    if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    }
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
export async function fetchVideoMetadata(videoId) {
    const url = `${BACKEND_URL}/api/youtube/${videoId}`;
    console.log('Fetching YouTube data for video:', videoId);
    try {
        const response = await fetch(url);
        console.log('YouTube API response status:', response.status);
        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            console.error('YouTube API error:', errorData);
            if (response.status === 403) {
                throw new Error('YouTube API quota exceeded or invalid API key');
            }
            else if (response.status === 404) {
                throw new Error('Video not found or private');
            }
            else if (response.status === 400) {
                throw new Error('Invalid API key or malformed request');
            }
            else {
                throw new Error(`YouTube API error: ${response.status}`);
            }
        }
        const data = await response.json();
        console.log('YouTube API data:', data);
        if (!data.items || data.items.length === 0) {
            throw new Error('Video not found or private');
        }
        const videoData = data.items[0];
        const thumbnail = videoData.snippet.thumbnails.medium;
        return {
            title: videoData.snippet.title,
            thumbnail: {
                url: thumbnail.url,
                width: thumbnail.width,
                height: thumbnail.height,
            },
            duration: videoData.contentDetails.duration,
            durationFormatted: formatDuration(videoData.contentDetails.duration),
        };
    }
    catch (error) {
        console.error('YouTube fetch error:', error);
        if (error instanceof Error) {
            throw error;
        }
        throw new Error('Unable to connect to YouTube. Check your internet connection.');
    }
}
